import { render, staticRenderFns } from "./CategoryForm.vue?vue&type=template&id=5ae6cf62&"
import script from "./CategoryForm.vue?vue&type=script&lang=ts&"
export * from "./CategoryForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports